module.exports = __webpack_public_path__ + "static/media/bingo_fun_in_the_sun.0d70ba40.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/bingo_fun_in_the_sun.png
// module id = 697
// module chunks = 0